<template>
  <div class="w-100">
    <b-row class="no-gutters px-3 px-sm-0 mt-2">
      <b-col cols="12" lg="7" class="overflow-auto">
        <b-button-group
          class="btn-group-status d-inline-flex d-inline-md-block"
        >
          <b-button
            v-for="(item, index) in filterOrderList"
            :key="index"
            @click="getDataByClickOrderType(item.id)"
            :class="{ menuactive: isActive(item.id) }"
            >{{ item.name }}</b-button
          >
        </b-button-group>
      </b-col>
      <b-col cols="12" lg="5" class="text-right">
        <b-button v-b-toggle.sidebar-1 class="btn-filter mr-3">
          <font-awesome-icon
            icon="filter"
            title="filter-btn"
            class="text-white mr-0 mr-sm-1"
          />
          <span class="d-none d-sm-inline">
            {{ $t("filter") }} ({{
              countStartdate + countEnddate
            }})</span
          >
        </b-button>
        <b-button
          class="btn-main w-auto-mobile text-uppercase"
          @click="exportInvoiceTax"
          >{{ $t("downloadList") }} </b-button
          >
      </b-col>
    </b-row>
    
    <div class="mt-2 bg-white p-3 p-sm-0">
      <b-row class="no-gutters">
        <b-col>
          <b-table
            striped
            responsive
            hover
            :items="items"
            :fields="fields"
            :busy="isBusy"
            show-empty
            :empty-text="$t('noData')"
            class="table-list"
          >
            <!-- <template #thead-top="">
              <b-tr>
                <b-th colspan="5"></b-th>
                <b-th colspan="4">ค่าธรรมเนียม</b-th>
                <b-th></b-th>
              </b-tr>
            </template> -->

            <template v-slot:cell(statementNumber)="data">
              <span> {{ data.item.statementNumber || '-' }} </span>
            </template>
            <template v-slot:cell(invoiceNumber)="data">
              <span> {{ data.item.invoiceNumber || '-' }} </span>
            </template>
            <template v-slot:cell(totalSales)="data">
              <span> ฿ {{ data.item.totalSales | numeral("0,0.00") }} </span>
            </template>
            <template v-slot:cell(totalDiscount)="data">
              <span> ฿ {{ data.item.totalDiscount | numeral("0,0.00") }} </span>
            </template>
            <template v-slot:cell(totalSalesAfterDiscount)="data">
              <span> ฿ {{ data.item.totalSalesAfterDiscount | numeral("0,0.00") }} </span>
            </template>
            <template v-slot:cell(sellerFee)="data">
              <span>
                ฿ {{ data.item.sellerFee | numeral("0,0.00") }}
              </span>
            </template>
            <template v-slot:cell(getfinFee)="data">
              <span>
                ฿ {{ data.item.getfinFee | numeral("0,0.00") }}
              </span>
            </template>
            <template v-slot:cell(paymentFee)="data">
              <span>
                ฿ {{ data.item.paymentFee | numeral("0,0.00") }}
              </span>
            </template>
            <template v-slot:cell(shippingFee)="data">
              <span>฿ {{ data.item.shippingFee+data.item.codFee | numeral("0,0.00") }}</span>
            </template>
            <template v-slot:cell(grandTotal)="data">
              <span> ฿ {{ data.item.grandTotal | numeral("0,0.00") }} </span>
            </template>
            <template v-slot:cell(withdrawFee)="data">
              <span> ฿ {{ data.item.withdrawFee | numeral("0,0.00") }} </span>
            </template>
            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col
          class="form-inline justify-content-center justify-content-sm-between"
        >
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.pageNo"
              :total-rows="rows"
              :per-page="filter.perPage"
              class="m-md-0"
              @change="pagination"
              align="center"
            ></b-pagination>

            <div class="ml-2">
              <p class="total-record-paging text-nowrap text-center">
                {{ totalRowMessage }}
              </p>
            </div>
          </div>

          <b-form-select
            class="mr-sm-3 select-page"
            v-model="filter.perPage"
            @change="hanndleChangePerpage"
            :options="pageOptions"
          ></b-form-select>
        </b-col>
      </b-row>
    </div>
    <b-sidebar
      id="sidebar-1"
      :title="$t('filter')"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      ref="filterSidebar"
    >
      <div class="px-3 py-2">
        <b-row>
          <b-col class="d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-link px-0"
              @click="onClearFilter()"
            >
              {{ $t("clear") }}
            </button>
          </b-col>
        </b-row>

        <div class="col-12"></div>
        <b-row class="mb-2">
          <b-col>
            <p class="main-label">{{ $t("startDate") }}</p>
            <datetime
              :placeholder="$t('selectDate')"
              v-model="filter.startDate"
              class="date-picker"
              format="dd MMM yyyy"
            ></datetime>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <p class="main-label">{{ $t("endDate") }}</p>
            <datetime
              :placeholder="$t('selectDate')"
              v-model="filter.endDate"
              class="date-picker"
              format="dd MMM yyyy"
            ></datetime>
          </b-col>
        </b-row>
        <div class="text-center">
          <p class="text-danger" v-if="errorDate">{{ $t("correctDate") }}</p>
        </div>
        <b-row>
          <b-col class="d-flex justify-content-center">
            <button
              type="button"
              class="btn btn-purple button"
              @click="getDataFilter()"
            >
              {{ $t("search") }}
            </button>
          </b-col>
        </b-row>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputText from "@/components/inputs/InputText";
import axios from "axios";
import * as moment from "moment/moment";

export default {
  name: "FinanceOrderOverview",
  components: {
    InputSelect,
    InputText,
  },
  data() {
    return {
      filterOrderList: [
        {count: 0, id: 1, name: "รายการคำสั่งซื้อที่สำเร็จ"},
        {count: 0, id: 2, name: "รายการคำสั่งซื้อที่มีค่าปรับ"},
        {count: 0, id: 3, name: "รายการคำสั่งซื้อที่ยังไม่ได้ชำระ"}
      ],
      modalMessage: "",
      activeItem: "",
      requestDeleteUser: {
        userId: null,
      },
      fields: [
        {
          key: "statementNumber",
          label: `${this.$t("statementNumber")}`,
          stickyColumn: true,
          class: "w-100px",
        },
        {
          key: "invoiceNumber",
          label: `${this.$t("orderNo")}`,
          stickyColumn: true,
          class: "w-100px",
        },
        {
          key: "totalSales",
          label: `${this.$t("totalSales")}`,
          class: "w-100px",
        },
        {
          key: "totalDiscount",
          label: `${this.$t("totalDiscount")}`,
          class: "w-100px",
        },
        {
          key: "totalSalesAfterDiscount",
          label: `${this.$t("salesAfterDiscount")}`,
          class: "w-100px",
        },
        {
          key: "sellerFee",
          label: `${this.$t("salesFee")}`,
          class: "w-225px",
        },
        {
          key: "getfinFee",
          label: `${this.$t("platformAdministrationFee")}`,
          class: "w-225px",
        },
        {
          key: "paymentFee",
          label: `${this.$t("paymentTransactionFee")}`,
          class: "w-225px",
        },
        {
          key: "shippingFee",
          label: `${this.$t("shippingAndCODFees")}`,
          class: "w-100px",
        },
        {
          key: "withdrawFee",
          label: `${this.$t("getfinService")}`,
          class: "w-225px",
        },
        {
          key: "grandTotal",
          label: `${this.$t("grandtotal")}`,
          class: "w-100px",
        }
      ],
      items: [],
      isBusy: false,
      rows: 0,
      filter: {
        startDate: "",
        endDate: "",
        perPage: 10,
        pageNo: 1,
      },
      filterSubmit: {
        startDate: "",
        endDate: "",
        perPage: 10,
        pageNo: 1,
      },
      pageOptions: [
        { value: 10, text: `10 / ${this.$t("page")}` },
        { value: 30, text: `30 / ${this.$t("page")}` },
        { value: 50, text: `50 / ${this.$t("page")}` },
        { value: 100, text: `100 / ${this.$t("page")}` },
      ],
      totalRowMessage: "",
      isDisable: false,
      selected: [],
      selectedAll: false,
      checkAll: false,
      selectAllCb: false,
      errorDate: false,
      id: -1,
      param :{
        formStatus: 0
      }
    };
  },
  created: async function () {
    if(this.$route.params.id) this.id = this.$route.params.id;
    if(this.$route.params.formStatus) this.param.formStatus = this.$route.params.formStatus;
    if(this.$route.params.tab){
      this.activeItem = parseInt(this.$route.params.tab);
    } else{
      this.activeItem = 0;
    }

    await this.getList();
  },
  computed: {
    countStartdate: function () {
      var count = 0;
      if (this.filterSubmit.startDate != "") count += 1;
      else if (count > 0) count -= 1;
      return count;
    },
    countEnddate: function () {
      var count = 0;

      if (this.filterSubmit.endDate != "") count += 1;
      else if (count > 0) count -= 1;
      return count;
    },
  },
  methods: {
    getList: async function () {
      this.isBusy = true;
      var financeId = this.id;
      var path = '';
      if (this.activeItem == 1) path = 'OrderOverviewComplete';
      else if(this.activeItem == 2) path = 'OrderOverViewOverdue';
      else if(this.activeItem == 3) path = 'OrderOverviewWait';

      if(this.param.formStatus == 0){
        if (this.activeItem == 1) financeId = 0;
        else if(this.activeItem == 2) financeId = -1;
        else if(this.activeItem == 3) financeId = 0;
      }

      this.filterSubmit = {...this.filter};
      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/Finance/${path}/${financeId}`,
        null,
        this.$headers,
        this.filterSubmit
      );
      if (resData.result == 1) {
        this.items = resData.detail.dataList;
        this.rows = resData.detail.count;

        this.isBusy = false;
        this.$isLoading = true;
      }
    },
    getDataFilter() {
      if (this.filter.startDate > this.filter.endDate && this.filter.endDate != "") {
        this.errorDate = true;
        return;
      }

      this.errorDate = false;
      this.filter.pageNo = 1;
      this.getList();
      this.$refs.filterSidebar.hide(true);
    },
    getDataByClickOrderType(id) {
      this.filter.pageNo = 1;
      this.filter.startDate = "";
      this.filter.endDate = "";
      this.activeItem = id;
      this.getList(id);
    },
    onClearFilter() {
      this.filter.pageNo = 1;
      this.filter.startDate = "";
      this.filter.endDate = "";
      this.errorDate = false;
      this.$refs.filterSidebar.hide(true);
      this.getList();
    },
    isActive: function (menuItem) {
      return this.activeItem == menuItem;
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
    },
    hanndleChangePerpage(value) {
      this.filterSubmit.pageNo = 1;
      this.filterSubmit.perPage = value;
      this.getList();
    },
    exportInvoiceTax: async function () {
      var financeId = this.id;
      var path = '';
      if (this.activeItem == 1) path = 'complete';
      else if(this.activeItem == 2) path = 'overdue';
      else if(this.activeItem == 3) path = 'wait';
      
      axios({
        url: `${this.$baseUrl}/api/Finance/ExportOrderOverview/${path}/${financeId}`,
        method: "post",
        headers: this.$headers,
        responseType: "blob",
        data: {}
      })
      .then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");
        var dateExcel = moment().format("DDMMYYYYhhmmss");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `Tax-Invoice-` + dateExcel + `.xlsx`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch(error => {
        console.log(error);
      });
    },
  },
};
</script>

<style scoped>
.status-count-label {
  font-size: 20px;
  color: #1085ff;
}

.card-status {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  margin-bottom: 1.5rem;
  word-wrap: break-word;
  background-clip: border-box;
  border: 1px solid;
  border-radius: 0.25rem;
  background-color: #fff;
  border-color: #d8dbe0;
}

.finance-icon {
  width: auto;
  height: 35px;
}

.total-box {
  border: 2px solid #1085ff;
}
::v-deep .w-225px {
  min-width: 225px !important;
}
::v-deep table th.b-table-sticky-column:nth-child(2),
::v-deep table td.b-table-sticky-column:nth-child(2) {
  left: 160px !important;
}

@media (min-width: 767px) {
  .statusCardLists-box {
    margin-right: -5px;
    margin-left: -5px;
  }
}

@media (max-width: 767.98px) { 
  ::v-deep table th.b-table-sticky-column:nth-child(2),
  ::v-deep table td.b-table-sticky-column:nth-child(2) {
    left: 0 !important;
  }
}
</style>
